<template>
  <div class="page">
    <h1>個案管理</h1>
    <div id="accordion" class="mySearchPanel">
      <div class="card col-md-12">
        <h3 class="mb-0">
          <div class="search-container">
            <i class="fa fa-search"></i>
<!--            //CC search to template-->
            <input class="form-control mySearchPanel_txtKeyword"  type="text" v-model="search">
<!--            <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">-->
<!--              進階搜尋-->
<!--            </button>-->
          </div>
        </h3>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body queryPanel_body">
            <div class="form-group row">

<!--              <div v-for="(item,index) in fieldDefines" :key="index" class="col-sm-3">-->
<!--                <div class="col-sm-12" >-->
<!--                  <SearchFormField :model-defined="item" :model-field.sync="item.InputValue" :model-field_-s.sync="item.InputValue_S" :model-field_-e.sync="item.InputValue_E"  :role="role" v-if="item.Visible && havePermission(item)"></SearchFormField>-->
<!--                </div>-->
<!--              </div>-->

            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="row mySearchPanel_toolbar d-flex ">-->
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">查詢</a>-->
<!--      <a class="btn btn-primary mybutton" href="javascript:location.reload()" >清除搜尋</a>-->
<!--      <a class="btn btn-danger mybutton" href="#" @click="deleteItem">刪除</a>-->
<!--      <a class="btn btn-info mybutton " href="#" @click="addItem">新增</a>-->
<!--    </div>-->


<!--    情境篩選-->
<!--    <div class="row mySearchPanel_toolbar d-flex ">-->
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">加星號</a>-->
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">本周需追蹤者</a>-->
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">本月需追蹤者</a>-->
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">已逾期</a>-->
<!--    </div>-->


    <v-app id="inspire" class="myGridPanel">
      <v-data-table
          ref="grid"
          :headers="headers"
          :items="gridDatas"
          item-key="SystemId"
          :items-per-page="20"
          class="elevation-1"
          show-select
          :single-select=false
          :footer-props="gridFooterProps"
          v-model="gridMeta.selectedRecord"
          :search="search"
      >
        <!--        v-model="selectedRecord"-->
<!--        <template v-slot:item.TITLE="{item}">-->
<!--          {{item.TITLE|fmtTitle}}-->
<!--        </template>-->
        <template v-slot:item.created_at="{item}">
          {{item.created_at|fmtDate}}
        </template>
<!--        <template v-slot:item.ORDERKEY="{item}">-->
<!--          <input type="text" class="form-control"  name="name" placeholder="" v-model.lazy="item.ORDERKEY" v-numeric-or-empty @change="updateOrderKey(item,item.ORDERKEY)" style="width: 80px">-->
<!--        </template>-->
<!--        <template v-slot:item.STATUS="{item}">-->
<!--          <a href="#" v-if="item.STATUS==='1'" @click="updateStatus(item,'0')"><v-icon>far fa-circle</v-icon></a>-->
<!--          <a href="#" v-if="item.STATUS!=='1'" @click="updateStatus(item,'1')"><v-icon>fas fa-times</v-icon></a>-->
<!--        </template>-->
        <template v-slot:item.actions="{ item }">
          <a class="btn btn-primary" style="color:white" @click="editItem(item,false)">編輯</a>
          <a class="btn btn-primary" style="color:white;margin-left: 10px" @click="editItem(item,true)">另開頁籤</a>
        </template>
        <template v-slot:item.isFinish="{ item }">
          <div v-if="item.isFinish">
            <a role="button" class="btn btn-secondary" style="color:white" href="#" @click="changeStatus(item.id,false)">是</a>
          </div>
          <div v-else>

            <a role="button" class="btn btn-danger" style="color:white" href="#" @click="changeStatus(item.id,true)">否</a>
          </div>
        </template>

      </v-data-table>
    </v-app>
  </div>
</template>

<script>
import dec from "../../util/declare";
import apiTzsci from "@/views/tzsci/js/apiTzsci";
import util from "@/util/util";
import _ from "lodash";

export default {
  data () {
    return {
      type:"",
      headers:[
        // {
        //   text: '案號',
        //   align: 'start',
        //   value: '案號',
        // },
        { text: '登入帳號(手機)', value: 'email',width: "120px" },
        { text: '姓名', value: 'name',width: "120px" },
        { text: '別名', value: 'alias',width: "120px" },
        { text: '縣市', value: 'area',width: "150px" },
        { text: '風險等級', value: 'riskLevel' },
        { text: '標籤1', value: 'caseMag_Tag1' },
        { text: '個案備註', value: 'caseMag_Content' },
        { text: '是否確認', value: 'isFinish' },
        { text: '註冊日', value: 'created_at' },
        { text: '操作', value: 'actions', sortable: false ,width: "200px"},
      ],
      gridFooterProps: dec.GridFooterProps,
      gridMeta:{
        selectedRecord:[]
      },
      gridDatas: [ ],
      search:"",
      DS_UserManual:dec.DS_UserManual,
      searchFieldDefines:{},
      searchKeywordFields:{},
      queryRiskLevel:"",
      queryIsFinish:"",
    }
  },
  methods: {
    queryItem(){
      let that=this

      let loader=util.ShowLoading(that);
      apiTzsci.api_Admin_GetUsers()
          .then((data)=>{
            that.gridDatas=data;

            // if (that.queryTag !==""){
            //   that.gridDatas=_.filter(that.gridDatas, function(o) {
            //     return o.tag1 ===that.queryTag || o.tag2 ===that.queryTag ||o.tag3 ===that.queryTag;
            //   });
            // }

            if (that.queryRiskLevel){
              that.gridDatas=_.filter(that.gridDatas, function(o) {
                return o.riskLevel ===that.queryRiskLevel;
              });
            }

            if (that.queryIsFinish){
              that.gridDatas=_.filter(that.gridDatas, function(o) {
                return o.isFinish ===that.queryIsFinish;
              });
            }
            //customize
            // that.gridDatas.forEach( item => {
            //   item.合約金額_原合約幣別=format.to_money2(item.合約金額_原合約幣別)
            //
            //   item.承辦業務=format.joinField(item.GPK1承辦業務,item.GPK2承辦業務,item.FEC北區承辦業務,item.FEC中區承辦業務,item.高治承辦業務)
            //
            // });

            util.HideLoading(loader);
          })
    },
    addItem(){
      this.$router.push({ name: 'MemberEdit', query: { id: '',type:this.type }})
    },
    editItem (item,openWindow) {
      // util.ShowMessage(item.id)
      if (openWindow){
        window.open("/MemberEdit?id="+item.id+"&type="+this.type)
      }else{
        this.$router.push({ name: 'MemberEdit', query: { id: item.id ,type:this.type}})
      }
      // this.editedIndex = this.gridDatas.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true

    },
    deleteItem(){
      // let ids=this.gridMeta.selectedRecord.map(s => s.SystemId);
      //
      // if (ids.length>0){
      //   if (confirm('Are you sure you want to delete this item?')){
      //     apiGPK.api_Delete_Form(ids).then(()=>this.queryItem(false))
      //   }
      // }else{
      //   util.ShowMessage('Please select item first.');
      // }
    },
    async changeStatus(id,isFinish){
      apiTzsci.api_Admin_UpdateCase_IsFinish(id,isFinish).then((data)=>{
        if (data.data.status==="success") {
          this.queryItem();
        } else {
          alert(data.data.msg);
        }
      })
    },
    // updateStatus(item,status){
    //   apiAdmin.COMM_Update_Status(item.ID,dec.TableName_USER_MANUAL,status).then(()=>{
    //     item.STATUS=status
    //   })
    // },
    // updateOrderKey(item,orderKey){
    //   apiAdmin.COMM_Update_OrderKey(item.ID,dec.TableName_USER_MANUAL,orderKey).then(()=>{
    //
    //   })
    // }
  },
  created() {

  },
  mounted() {
    this.queryRiskLevel=this.$route.query.riskLevel;
    this.queryIsFinish=this.$route.query.isFinish;
    this.queryItem();
  },
}
</script>



<style scoped>
.page{
  max-width: 1400px;
}
</style>
